import { LocalePrefix } from '@tmh-website/shared/const';
import JSCookie from 'js-cookie';
import ky from 'ky';
import { getStoreHeaders } from './graphql.service';
import { getCustomerDataModule } from './customer-data.service';

export interface CustomerCompareList {
  uid: string;
  /**
   * List of product uids
   */
  items: string[];
}

export async function getCompareListData(locale: LocalePrefix): Promise<CustomerCompareList> {
  const customerData = await getCustomerDataModule(locale);
  const res = await customerData.reload(['compare-products'], false);

  const compareProducts = res['compare-products'];
  const items = compareProducts.items.map(item => window.btoa(item.id));
  return {
    uid: compareProducts.data_id.toString(),
    items,
  };
}

/**
 * Adds a given item to the user's compare list.
 */
export async function addProductToCompareList(productUid: string, locale: LocalePrefix): Promise<void> {
  const params = new URLSearchParams();
  params.set('form_key', JSCookie.get('form_key')!);
  params.set('product', window.atob(productUid));
  params.set('uenc', window.btoa(window.location.href));

  await ky.post(`/${locale}/catalog/product_compare/add`, { body: params, headers: getStoreHeaders(locale) });
}

/**
 * Removes a given item from the user's compare list.
 */
export async function removeProductFromCompareList(productUid: string, locale: LocalePrefix): Promise<void> {
  const params = new URLSearchParams();
  params.set('form_key', JSCookie.get('form_key')!);
  params.set('product', window.atob(productUid));
  params.set('confirmation', 'true');
  params.set('confirmationMessage', '');
  params.set('uenc', window.btoa(window.location.href));

  await ky.post(`/${locale}/catalog/product_compare/remove`, { body: params, headers: getStoreHeaders(locale) });
}
